export const TrainingModalInput = [
  {
    label: "Exercise No.",
    type: "text",
    placeholder: "Enter exercise number",
    valueKey: "exercise_number",
  },
  {
    label: "Exercise",
    type: "text",
    placeholder: "Enter exercise name",
    valueKey: "name",
  },
  {
    label: "Exercise type: Normal/ Superset/ Dropset",
    type: "select",
    options: ["Normal", "Superset", "Dropset"],
    valueKey: "exercise_type",
  },
  {
    label: "Weighted",
    type: "text",
    placeholder: "Yes/No",
    valueKey: "weighted",
  },
  {
    label: "Sets",
    type: "text",
    placeholder: "Enter number of sets",
    valueKey: "sets",
  },
  {
    label: "Reps",
    type: "text",
    placeholder: "Enter number of reps",
    valueKey: "reps",
  },
  {
    label: "Time Based",
    type: "text",
    placeholder: "Yes/No",
    valueKey: "time_based",
  },
  {
    label: "Set Time",
    type: "text",
    placeholder: "Enter time (e.g., 60 Sec)",
    valueKey: "set_time",
  },
  {
    label: "Rest Time",
    type: "text",
    placeholder: "Enter time (e.g., 60 Sec)",
    valueKey: "rest_time",
  },
  // {
  //   label: "Inter Exercise Rest",
  //   type: "text",
  //   placeholder: "Enter time (e.g., 60 Sec)",
  //   valueKey: "inter_exercise_rest",
  //   defaultValue: 0,
  // },
  {
    label: "Set End Rest Time",
    type: "text",
    placeholder: "Enter time (e.g., 60 Sec)",
    valueKey: "set_end_rest_time",
    defaultValue: 0,
  },
  {
    label: "Video URL",
    type: "text",
    placeholder: "Enter video URL",
    valueKey: "video_url",
  },
  {
    label: "Image URL",
    type: "text",
    placeholder: "Enter image URL",
    valueKey: "image_url",
  },
  {
    label: "Superset Names",
    type: "text",
    placeholder: "Enter superset names (comma-separated)",
    valueKey: "superset_names",
  },
];
